import { render, staticRenderFns } from "./OTPValidation.vue?vue&type=template&id=6f239d77&scoped=true&"
import script from "./OTPValidation.vue?vue&type=script&lang=js&"
export * from "./OTPValidation.vue?vue&type=script&lang=js&"
import style0 from "./OTPValidation.vue?vue&type=style&index=0&id=6f239d77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f239d77",
  null
  
)

export default component.exports